// jshint esversion:6,asi:true
export default {
  name: '乐橙谷职业能力测评系统',
  icp: '京ICP备15067284号-3',
  version: 'Alpha v2.7.0',
  regex: {
    name: /^[\da-zA-Z\u4E00-\u9FA5]{1,16}$/i,
    email: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
    phone: /^1\d{10}$/,
    // phone: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,2,5-9]))\d{8}$/,
    password: /((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*])|(?=.*\d)(?=.*[#@!~%^&*]))[a-z\d#@!~%^&*]{6,16}/i,
    tel: /^(0\\d{2}-\\d{8}(-\\d{1,4})?)|(0\\d{3}-\\d{7,8}(-\\d{1,4})?)$/,
    invite_code: /^[a-z0-9A-Z]{6}$/,
    verify_code: /^[a-z0-9A-Z]{6}$/,
    code: /^[a-z0-9A-Z]{6}$/,
    age: /^[1-9]\d?$/,
    id: /^[0-9a-f]{24}$/i
  },
  text: {
    work_years: ['应届生', '1年', '2年', '3年', '4年', '5年', '6年', '7年', '8年', '9年', '10年', '10年以上'],
    resume_status: {
      1: '新增',
      2: '考虑',
      3: '不考虑',
      4: '入职'
    },
    invitation_status: {
      1: '未发送',
      2: '已发送',
      3: '已测评'
    }
  }
}



// WEBPACK FOOTER //
// ./src/global.js